import styled from 'styled-components';

const Body = styled.div`
  width: 100vw;
  min-height: calc(100vh - 60px);

  display: flex;
  flex-direction: column;
  gap: 20px;

  padding: 20px;
  padding-bottom: 100px;

  @media only screen and (min-width: 768px) {
    width: 50vw;
    margin: 0 auto;
  }
`;

export default Body;
